var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import LinkSvg from './link-01.icon.svg';
export const LinkIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: LinkSvg }));
_react_refresh_temp_1 = LinkIcon;
$RefreshReg$(_react_refresh_temp_1, "LinkIcon");
